/**
 * CAOSLAB.DEV — TECHNICAL BLOG & ARTICLE READER MODULE
 * High-performance, dynamic blog architecture on Firestore
 */

// Baseline default posts list (Cleared — ready for live dynamic Firestore entries)
export const BLOG_POSTS = [];

export function renderEmptyBlogState() {
  return `
    <div class="empty-blog-state glass-card cyber-corners" style="grid-column: 1 / -1; text-align: center; padding: 70px 24px; border: 1px dashed rgba(212,175,55,0.3); background: rgba(12,12,18,0.7); max-width: 800px; margin: 0 auto; width: 100%;">
      <div style="width: 72px; height: 72px; margin: 0 auto 20px auto; border-radius: 50%; background: rgba(212,175,55,0.1); border: 1px solid rgba(212,175,55,0.3); display: flex; align-items: center; justify-content: center;">
        <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5">
          <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
        </svg>
      </div>
      <span class="admin-badge" style="margin-bottom: 12px;">PUBLICACIONES PRÓXIMAMENTE</span>
      <h3 style="font-size: 1.5rem; color: #ffffff; margin-bottom: 12px; font-family: var(--font-heading);">Nuevos Artículos en Preparación</h3>
      <p style="color: var(--text-muted); max-width: 560px; margin: 0 auto 28px auto; font-size: 0.95rem; line-height: 1.6;">
        Estamos elaborando investigaciones técnicas y guías de ingeniería sobre <strong>GEO (Generative Engine Optimization), Agentes de IA Autónomos y Arquitecturas de Ultra Baja Latencia</strong>. Las publicaciones estarán disponibles el próximo mes.
      </p>
      <div style="display: flex; justify-content: center; gap: 14px; flex-wrap: wrap;">
        <a href="/#contacto" class="btn btn-gold shimmer-element">
          Agendar Consulta Técnica
        </a>
        <a href="/" class="btn btn-outline">
          Conocer Servicios
        </a>
      </div>
    </div>
  `;
}

export function initBlogModule() {
  const gridContainer = document.getElementById('blog-posts-grid');
  const filterButtons = document.querySelectorAll('.blog-filter-btn');

  if (!gridContainer) return;

  function renderPosts(category = 'all') {
    const filtered = category === 'all' 
      ? BLOG_POSTS 
      : BLOG_POSTS.filter(p => p.categoryKey === category);

    if (filtered.length === 0) {
      gridContainer.innerHTML = renderEmptyBlogState();
      return;
    }

    gridContainer.innerHTML = filtered.map(post => `
      <article class="blog-card glass-card cyber-corners" data-article-id="${post.id}">
        <div class="blog-card-header">
          <div class="blog-card-art">
            <div style="width: 80px; height: 80px; border-radius: 50%; border: 2px dashed rgba(212,175,55,0.4); display: flex; align-items: center; justify-content: center;">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5">
                <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
              </svg>
            </div>
          </div>
          <span class="blog-category-badge">${post.category}</span>
        </div>
        <div class="blog-card-body">
          <div class="blog-meta">
            <span class="blog-meta-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              ${post.readTime}
            </span>
            <span class="blog-meta-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              ${post.date}
            </span>
          </div>
          <h3 class="blog-title">${post.title}</h3>
          <p class="blog-excerpt">${post.excerpt}</p>
          <div class="blog-read-more">
            Leer Artículo
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </div>
        </div>
      </article>
    `).join('');
  }

  // Filter Buttons
  filterButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      filterButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const cat = btn.getAttribute('data-filter');
      renderPosts(cat);
    });
  });

  // Initial render
  renderPosts('all');
}
